import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit, OnChanges {
  @Input() text = 'Default Text';
  @Input() size = 'small';
  @Input() color = '#005B96';
  textColor = '#FFFFFF';
  badgeClass = '';

  ngOnInit() {
    this.updateTextColor();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['color']) {
      this.updateTextColor();
    }
  }

  private updateTextColor(): void {
    this.textColor = this.isLight(this.color) ? '#000000' : '#FFFFFF';
    this.badgeClass = `app-badge ${this.size} width-fit-content`;
  }

  /**
   * Determines if a color is light based on its brightness.
   * Uses a brightness algorithm that weighs the red, green, and blue components of the color.
   *
   * @param color The color in HEX format, e.g., "#FFFFFF".
   * @return Returns true if the color is light, otherwise returns false.
   */
  private isLight(color: string): boolean {
    // Remove the '#' character from the string, if present, to obtain the pure hexadecimal value
    const hex = color.replace('#', '');
    // Parsing the hexadecimal values for the red, green, and blue components
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    // Calculating the color brightness using the formula:
    // brightness = (299*r + 587*g + 114*b) / 1000
    // The coefficients 299, 587, and 114 reflect the different impact of red, green, and blue light
    // on human perception of brightness.
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    // Comparing the brightness with the threshold value of 128, which is an approximate midpoint
    // between light and dark tones.
    return brightness > 128;
  }
}

